namespace Gamification.Gamification {
    export interface UtentiProdottiRow {
        IdUtenteProdotto?: number;
        UserId?: number;
        TenantId?: number;
        IdUtente?: number;
        IdProdotto?: number;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
        Classi?: number[];
    }

    export namespace UtentiProdottiRow {
        export const idProperty = 'IdUtenteProdotto';
        export const localTextPrefix = 'Gamification.UtentiProdotti';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdUtenteProdotto = "IdUtenteProdotto",
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtente = "IdUtente",
            IdProdotto = "IdProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione",
            Classi = "Classi"
        }
    }
}
